<template>
	<div class="home">
		<v-col class="pt-5">
			<!-- top banner -->
			<div class="pt-3 pb-5">
				<v-row>
					<v-col cols="12" sm="12" md="10">
						<v-carousel light cycle hide-delimiter-background show-arrows-on-hover class="rounded-lg slider-h-100">
							<v-carousel-item v-for="(slide, i) in banner.slide" :key="i">
								<v-sheet>
									<v-row align="center" justify="center">
										<v-img eager :src="slide.banner_image" :title="slide.banner_title" v-if="slide.banner_is_active == 'Aktif'"></v-img>
									</v-row>
								</v-sheet>
							</v-carousel-item>
						</v-carousel>
					</v-col>
					<v-col cols="12" sm="12" md="3">
						<v-row v-if="banner.rightBanner.length > 0">
							<v-col cols="12" class="pa-0 mb-3" v-for="(banner, idb) in banner.rightBanner" :key="idb">
								<v-img eager :src="banner.banner_image" :title="banner.banner_title" v-if="banner.banner_is_active == 'Aktif'"></v-img>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</div>

			<!-- Store Info Section -->
			<div class="pt-5" v-if="Object.keys(detailStore).length > 0">
				<v-card outlined class="hwi-border rounded-lg">
					<v-row class="px-3">
						<v-col cols="12" md="5">
							<v-row>
								<v-col cols="3" sm="2" md="3" class="py-0 pr-0 my-auto">
									<v-img width="100%" class="border" :src="detailStore.store_image ? detailStore.store_image : '/assets/seller/default-toko.jpg'"></v-img>
								</v-col>
								<v-col cols="9" sm="10" md="9" class="py-0">
									<router-link :to="{ name: 'store-detail', params: { slug: store_slug } }" class="text-deco">
										<div class="text-uppercase primary--text font-weight-bold text-subtitle-2">
											{{detailStore.store_name}}
										</div>
									</router-link>
									<div class="pt-1 text-caption text-body-sm-2">{{ detailStore.store_city_name + ', ' + detailStore.store_province_name }}</div>
									<div class="pt-1 text-caption text-body-sm-2">{{ detailStore.store_phone }}</div>
									<div class="d-flex pt-2" v-if="false">
										<v-btn outlined large color="primary" class="px-2 px-md-3 rounded-lg mr-2" v-if="false">
											<v-icon>mdi-chat-processing-outline</v-icon>
											<div class="pl-sm-2 text-caption text-body-sm-2 text-capitalize font-weight-bold d-none d-md-block">Kirim Pesan</div>
										</v-btn>
										<v-btn outlined large color="grey darken-1" class="rounded-lg" @click="gotoStore(detailStore.store_slug)">
											<v-icon>mdi-storefront-outline</v-icon>
											<div class="pl-sm-2 text-caption text-body-sm-2 text-capitalize font-weight-bold d-none d-md-block">Lihat Toko</div>
										</v-btn>
									</div>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="7" class="my-auto left-border text-body-2 d-none d-md-block">
							<v-row class="px-5 d-flex align-start">
								<v-col cols="5">
									<v-row class="d-flex flex-row justify-space-between">
										<v-col class="py-0">Status Toko</v-col>
										<v-col class="py-0 primary--text font-weight-bold text-right">{{ detailStore.store_is_active }}</v-col>
									</v-row>
									<v-row class="d-flex flex-row justify-space-between pt-2">
										<v-col cols="5" class="py-0">Bergabung</v-col>
										<v-col cols="7" class="py-0 primary--text font-weight-bold text-right">{{detailStore.store_input_datetime | tanggal}}</v-col>
									</v-row>
								</v-col>
								<v-col cols="1"></v-col>
								<v-col cols="6">
									<v-row class="d-flex flex-row justify-space-between">
										<v-col cols="5" class="py-0">Total Transaksi</v-col>
										<v-col cols="7" class="py-0 primary--text font-weight-bold text-right">{{ detailStore.total_transaction }}</v-col>
									</v-row>
									<v-row class="d-flex flex-row justify-space-between pt-2">
										<v-col class="py-0">Total Produk</v-col>
										<v-col class="py-0 primary--text font-weight-bold text-right">{{ detailStore.total_product }}</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card>
			</div>

			<!-- service info -->
			<div class="py-5">
				<v-card elevation="0" light class="rounded-lg bg-hwi-3 white--text">
					<v-col cols="12">
						<v-row>
							<v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
								<v-row>
									<v-col cols="3" class="my-auto py-0">
										<v-img src="/assets/icons/layanan-24-jam-icon.svg"></v-img>
									</v-col>
									<v-col cols="9" class="my-auto py-0">
										<div class="text-subtitle-2 font-weight-bold">Layanan 24/7</div>
										<div class="text-caption">Tim Support Handal dan Cepat untuk Anda</div>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
								<v-row>
									<v-col cols="3" class="my-auto py-0">
										<v-img src="/assets/icons/layanan-cepat-icon.svg"></v-img>
									</v-col>
									<v-col cols="9" class="my-auto py-0">
										<div class="text-subtitle-2 font-weight-bold">Layanan Cepat</div>
										<div class="text-caption">Pemesanan dan Pengiriman dalam 1 hari</div>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
								<v-row>
									<v-col cols="3" class="my-auto py-0">
										<v-img src="/assets/icons/transaksi-aman-icon.svg"></v-img>
									</v-col>
									<v-col cols="9" class="my-auto py-0">
										<div class="text-subtitle-2 font-weight-bold">Transaksi Aman</div>
										<div class="text-caption">Jaminan Keamanan dalam Bertransaksi</div>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
								<v-row>
									<v-col cols="3" class="my-auto py-0">
										<v-img src="/assets/icons/garansi-icon.svg"></v-img>
									</v-col>
									<v-col cols="9" class="my-auto py-0">
										<div class="text-subtitle-2">Garansi</div>
										<div class="text-caption">100% Produk Bermutu Dan Berkualitas</div>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</div>

			<!-- new product list -->
			<div class="pt-5">
				<div class="text-body-1 text-sm-h6 text-uppercase primary--text">Produk Terbaru</div>
				<div class="pt-4 pb-5">
					<v-row>
						<template v-if="!loadingProduct">
							<template v-if="latestProduct.lists.length >3">
								<v-col class="py-0" style="position: relative;">
									<carousel :loop="false" :nav="false" :dots="false" :margin="20" :responsive="{0:{items:1},600:{items:3},1000:{items:4}}">
										<div class="d-block" style="position: relative;" v-for="(item, idx) in latestProduct.lists" :key="item.product_id + '-' + idx">
											<router-link class="text-deco" :to="{ name: 'product-store-detail', params: { slug: store_slug, id: item.store_product_id }}">
												<v-card class="rounded-lg hwi-border" outlined style="height: 350px;">
													<span v-if="detailStore.store_free_delivery == 'Ya'" class="freeOngkir"></span>
													<v-chip
														close-icon="mdi-close-outline"
														color="red"
														x-small
														style="height: 20px; position: absolute; z-index: 99; right: 10px; top: 10px; display: inline-block; color: white; font-weight: bold; margin-bottom: 1rem;"
														v-if="item.store_product_stock_balance == 0"
													>
														<v-avatar left class="mr-0">
															<v-icon dense x-small>mdi-alert-circle-outline</v-icon>
														</v-avatar>

														STOK KOSONG
													</v-chip>
													<v-row class="pl-3">
														<v-col cols="12">
															<v-img height="230" width="80%" class="rounded-lg mx-auto" :src="item.store_product_product_image ? item.store_product_product_image : '/assets/product/default.png'"></v-img>
														</v-col>
														<v-col cols="12">
															<div class="grey--text text--darken-2">{{item.product_name}}</div>
															<template v-if="detailStore.store_free_delivery == 'Ya'">
																<div class="grey--text" v-if="item.product_is_complement == 'Ya'">Rp {{item.store_product_product_price | toNumber}}</div>
																<div class="grey--text" v-else>Rp {{item.store_product_product_price_margin | toNumber}}</div>
															</template>
															<div class="grey--text" v-else>Rp {{item.store_product_product_price | toNumber}}</div>
															<!-- <div class="grey--text">{{item.product_view_count}} dicari</div> -->
														</v-col>
													</v-row>
												</v-card>
											</router-link>
										</div>
										<template slot="prev">
											<v-card elevation="0" class="col-12 pa-0">
												<v-btn x-small color="white" elevation="3" fab class="prev prev-most-search"><v-icon color="grey darken-1">mdi-chevron-left</v-icon></v-btn>
											</v-card>
										</template>
										<template slot="next">
											<v-card elevation="0" class="col-12 pa-0">
												<v-btn x-small color="white" elevation="3" fab class="next next-most-search"><v-icon color="grey darken-1">mdi-chevron-right</v-icon></v-btn>
											</v-card>
										</template>
									</carousel>
								</v-col>
							</template>

							<template v-else>
								<v-col class="col-12 col-sm-12 col-md-3 py-0" v-for="(item, idx) in latestProduct.lists" :key="item.store_product_id + '-' + idx">
									<router-link class="text-deco" :to="{ name: 'product-store-detail', params: { slug: store_slug, id: item.store_product_id }}">
										<v-card class="rounded-lg hwi-border" outlined style="height: 350px;">
											<span v-if="detailStore.store_free_delivery == 'Ya'" class="freeOngkir"></span>
													<v-chip
														close-icon="mdi-close-outline"
														color="red"
														x-small
														style="height: 20px; position: absolute; z-index: 99; right: 10px; top: 10px; display: inline-block; color: white; font-weight: bold; margin-bottom: 1rem;"
														v-if="item.store_product_stock_balance == 0"
													>
														<v-avatar left class="mr-0">
															<v-icon dense x-small>mdi-alert-circle-outline</v-icon>
														</v-avatar>

														STOK KOSONG
													</v-chip>

											<v-row class="pl-3">
												<v-col cols="12">
													<v-img height="230" width="80%" class="rounded-lg mx-auto" :src="item.store_product_product_image ? item.store_product_product_image : '/assets/product/default.png'"></v-img>
												</v-col>
												<v-col cols="12">
													<div class="grey--text text--darken-2">{{item.product_name}}</div>
													<template v-if="detailStore.store_free_delivery == 'Ya'">
														<div class="grey--text" v-if="item.product_is_complement == 'Ya'">Rp {{item.store_product_product_price | toNumber}}</div>
														<div class="grey--text" v-else>Rp {{item.store_product_product_price_margin | toNumber}}</div>
													</template>
													<div class="grey--text" v-else>Rp {{item.store_product_product_price | toNumber}}</div>
													<!-- <div class="grey--text">{{item.product_view_count}} dicari</div> -->
												</v-col>
											</v-row>
										</v-card>
									</router-link>
								</v-col>
							</template>
						</template>

						<template v-else>
							<v-col class="col-12 col-sm-12 col-md-3 py-0" v-for="index in 4" :key="index">
								<v-sheet
									:color="`grey lighten-4`"
									class="pa-3"
								>
									<v-skeleton-loader class="mx-auto" max-width="100%" type="card"></v-skeleton-loader>
								</v-sheet>
							</v-col>
						</template>
					</v-row>
				</div>
			</div>

			<!-- middle banner -->
			<template v-if="banner.content.length > 0">
				<v-card elevation="0" class="banner-center col-12 pa-0">
					<template v-for="(banner, idb) in banner.content">
						<v-img :key="idb" width="100%" height="auto" class="rounded-lg mx-auto" :src="banner.banner_image" :title="banner.banner_title" v-if="banner.banner_is_active == 'Aktif'"></v-img>
					</template>
				</v-card>
			</template>

			<!-- most buy product list -->
			<div class="pt-5">
				<div class="text-body-1 text-sm-h6 text-uppercase primary--text">Produk Terlaris</div>
				<template v-if="!loadingProduct">
					<div class="pt-4 pb-5" v-if="mostBuyProduct.lists.length > 3">
						<carousel :loop="false" :nav="false" :dots="false" :margin="20" :responsive="{0:{items:2},600:{items:3},1000:{items:5}}">
							<div class="" v-for="item in mostBuyProduct.lists" :key="item.store_product_id">
								<router-link class="text-deco" :to="{ name: 'product-store-detail', params: { slug: store_slug, id: item.store_product_id }}">
									<v-card class="rounded-lg hwi-border" outlined height="290">
										<span v-if="detailStore.store_free_delivery == 'Ya'" class="freeOngkir"></span>
													<v-chip
														close-icon="mdi-close-outline"
														color="red"
														x-small
														style="height: 20px; position: absolute; z-index: 99; right: 10px; top: 10px; display: inline-block; color: white; font-weight: bold; margin-bottom: 1rem;"
														v-if="item.store_product_stock_balance == 0"
													>
														<v-avatar left class="mr-0">
															<v-icon dense x-small>mdi-alert-circle-outline</v-icon>
														</v-avatar>

														KOSONG
													</v-chip>

										<div class="mt-3">
											<v-img width="80%" height="160" class="rounded-lg mx-auto" :src="item.store_product_product_image ? item.store_product_product_image : '/assets/product/default.png'"></v-img>
											<div class="grey--text text--darken-2 px-3 col">
												<div class="pt-2 text-body-2 text-left primary--text font-weight-bold product-name-most">{{item.product_name}}</div>
												<div class="product-price mt-2" style="height: auto">
													<!-- <div class="text-decoration-line-through font-size-12 pink--text" v-if="item.product_price != item.product_price_origin">Rp {{item.product_price_origin | toNumber}}</div> -->
													<template v-if="detailStore.store_free_delivery == 'Ya'">
														<div class="text-subtitle-1 pt-1 font-weight-bold" v-if="item.product_is_complement == 'Ya'">Rp {{item.store_product_product_price | toNumber}}</div>
														<div class="text-subtitle-1 pt-1 font-weight-bold" v-else>Rp {{item.store_product_product_price_margin | toNumber}}</div>
													</template>
													<div class="text-subtitle-1 pt-1 font-weight-bold" v-else>Rp {{item.store_product_product_price | toNumber}}</div>
												</div>
												<!-- <div class="d-block text-caption mb-2"><span>0 terjual</span></div> -->
												<!-- <div class="d-block text-caption mb-2"><span>Stok {{ item.store_product_stock_balance | toNumber }}</span></div> -->
											</div>
										</div>
									</v-card>
								</router-link>
							</div>
							<template slot="prev">
								<v-card elevation="0" class="col-12 pa-0">
									<v-btn x-small color="white" elevation="3" fab class="prev prev-best-selling"><v-icon color="grey darken-1">mdi-chevron-left</v-icon></v-btn>
								</v-card>
							</template>
							<template slot="next">
								<v-card elevation="0" class="col-12 pa-0">
									<v-btn x-small color="white" elevation="3" fab class="next next-best-selling"><v-icon color="grey darken-1">mdi-chevron-right</v-icon></v-btn>
								</v-card>
							</template>
						</carousel>
					</div>

					<div class="pt-4 pb-5" v-else>
						<v-row>
							<v-col class="col-12 col-sm-12 col-md-3 py-0" v-for="item in mostBuyProduct.lists" :key="item.store_product_id">
								<router-link class="text-deco" :to="{ name: 'product-store-detail', params: { slug: store_slug, id: item.store_product_id }}">
									<v-card class="rounded-lg hwi-border" outlined height="290">
										<span v-if="detailStore.store_free_delivery == 'Ya'" class="freeOngkir"></span>
													<v-chip
														close-icon="mdi-close-outline"
														color="red"
														x-small
														style="height: 20px; position: absolute; z-index: 99; right: 10px; top: 10px; display: inline-block; color: white; font-weight: bold; margin-bottom: 1rem;"
														v-if="item.store_product_stock_balance == 0"
													>
														<v-avatar left class="mr-0">
															<v-icon dense x-small>mdi-alert-circle-outline</v-icon>
														</v-avatar>

														KOSONG
													</v-chip>
										<div class="mt-3">
											<v-img width="80%" height="160" class="rounded-lg mx-auto" :src="item.store_product_product_image ? item.store_product_product_image : '/assets/product/default.png'"></v-img>
											<div class="grey--text text--darken-2 px-3 col">
												<div class="pt-2 text-body-2 text-left primary--text font-weight-bold product-name-most">{{item.product_name}}</div>
												<div class="product-price mt-2" style="height: auto">
													<!-- <div class="text-decoration-line-through font-size-12 pink--text" v-if="item.product_price != item.product_price_origin">Rp {{item.product_price_origin | toNumber}}</div> -->
													
													<template v-if="detailStore.store_free_delivery == 'Ya'">
														<div class="text-subtitle-1 pt-1 font-weight-bold" v-if="item.product_is_complement == 'Ya'">Rp {{item.store_product_product_price | toNumber}}</div>
														<div class="text-subtitle-1 pt-1 font-weight-bold" v-else>Rp {{item.store_product_product_price_margin | toNumber}}</div>
													</template>
													<div class="text-subtitle-1 pt-1 font-weight-bold" v-else>Rp {{item.store_product_product_price | toNumber}}</div>
												</div>
												<!-- <div class="d-block text-caption mb-2"><span>0 terjual</span></div> -->
												<!-- <div class="d-block text-caption mb-2"><span>Stok {{ item.store_product_stock_balance | toNumber }}</span></div> -->
											</div>
										</div>
									</v-card>
								</router-link>
							</v-col>
						</v-row>
					</div>
				</template>

				<template v-else>
					<v-row>
						<v-col class="col-12 col-sm-12 col-md-3 py-0" v-for="index in 4" :key="index">
							<v-sheet
								:color="`grey lighten-4`"
								class="pa-3"
							>
								<v-skeleton-loader class="mx-auto" max-width="100%" type="card"></v-skeleton-loader>
							</v-sheet>
						</v-col>
					</v-row>
				</template>
			</div>

			<!-- all product list -->
			<div class="pt-5">
				<v-tabs class="no-slider">
					<div class="text-body-1 mb-0 text-sm-h6 text-uppercase primary--text">Semua Produk</div>
				</v-tabs>
				
				<div class="pt-5">
					<template v-if="!loadingProduct">
						<v-row class="ml-0" v-if="allProduct.lists.length > 0">
							<v-col class="pl-0 pt-0" cols="6" sm="3" md="2" v-for="product in allProduct.lists" :key="`${product.store_product_id}`">
								<v-hover v-slot:default="{ hover }">
									<router-link class="text-deco" :to="{ name: 'product-store-detail', params: { slug: store_slug, id: product.store_product_id}}">
										<v-card outlined class="rounded-lg" :elevation="hover ? 4 : 0">
											<span v-if="detailStore.store_free_delivery == 'Ya'" class="freeOngkir"></span>
													<v-chip
														close-icon="mdi-close-outline"
														color="red"
														x-small
														style="height: 20px; position: absolute; z-index: 99; right: 10px; top: 10px; display: inline-block; color: white; font-weight: bold; margin-bottom: 1rem;"
														v-if="product.store_product_stock_balance == 0"
													>
														<v-avatar left class="mr-0">
															<v-icon dense x-small>mdi-alert-circle-outline</v-icon>
														</v-avatar>

														KOSONG
													</v-chip>
											<div class="pa-2">
												<v-img :src="product.store_product_product_image ? product.store_product_product_image : '/assets/product/default.png'" height="150" class="rounded-lg"></v-img>
											</div>
											<v-col class="grey--text text--darken-2 px-2">
												<div class="text-body-2 product-name">{{ product.product_name }}</div>
												<div class="product-price mt-2">
													<!-- <div class="text-decoration-line-through font-size-12 pink--text" v-if="product.product_price != product.product_price_origin">Rp {{product.product_price_origin | toNumber}}</div> -->
													<template v-if="detailStore.store_free_delivery == 'Ya'">
														<div class="grey--text" v-if="product.product_is_complement == 'Ya'">Rp {{product.store_product_product_price | toNumber}}</div>
														<div class="grey--text" v-else>Rp {{product.store_product_product_price_margin | toNumber}}</div>
													</template>
													<div class="text-subtitle-1 pt-1 font-weight-bold" v-else>Rp {{product.store_product_product_price | toNumber}}</div>
												</div>
												<div v-if="false">
													<!-- <v-icon small color="yellow darken-1" v-for="i in fullRating(product.product_rating)" :key="'full'+i">mdi-star</v-icon> -->
													<!-- <v-icon small color="yellow darken-1" v-if="halfRating(product.product_rating, product.product_review_count)">mdi-star-half-full</v-icon> -->
													<!-- <v-icon small color="yellow darken-1" v-for="i in nullRating(product.product_rating)" :key="'half'+i">mdi-star-outline</v-icon> -->
													<!-- <v-rating empty-icon="mdi-star-outline" full-icon="mdi-star" half-icon="mdi-star-half-full" hover length="5" readonly size="12" color="yellow darken-1" :value="parseInt(product.product_rating) / parseInt(product.product_review_count)"></v-rating> -->
													<!-- <span class="pl-1 text-caption">({{product.product_review_count | toNumber}})</span> -->
												</div>
												<div class="text-caption">
													<!-- <span>{{product.product_sold_count | toNumber}} terjual</span> -->
												</div>
											</v-col>
										</v-card>
									</router-link>
								</v-hover>
							</v-col>
						</v-row>
					</template>

					<template v-else>
						<v-row>
							<v-col class="col-12 col-sm-12 col-md-2 py-0" v-for="index in 6" :key="index">
								<v-sheet
									:color="`grey lighten-4`"
									class="pa-3"
								>
									<v-skeleton-loader class="mx-auto" max-width="100%" type="card"></v-skeleton-loader>
								</v-sheet>
							</v-col>
						</v-row>
					</template>
				</div>
				<div class="py-4 text-center" v-if="allProduct.pagination.next > 0">
					<v-btn @click="loadMoreProductEx({page:allProduct.pagination.current + 1, limit: 12})" large outlined color="primary" class="rounded-lg text-capitalize" width="200" :loading="loadingProcess">Lihat Lainnya</v-btn>
				</div>
			</div>
		</v-col>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel'
// import { mapActions , mapState} from 'vuex'
// import authHelper from '@/helpers/auth'

export default {
	name: 'Home',
	components: {
		carousel
	},
	data () {
		return {
			loadingProcess: false,
			loadingProduct: false,
			isMobile: false,
			limitNav: 8,
			limitStore: 4,
			banner: {
				slide: [],
				rightBanner: [],
				content: []
			},
			store_slug: '',
			latestProduct: {
				lists: [],
				pagination: {}
			},
			allProduct: {
				lists: [],
				pagination: {}
			},
			mostBuyProduct: {
				lists: [],
				pagination: {}
			},
			detailStore: {}
		}
	},
	computed: {
		// ...mapState('product', ['productAll', 'productMostSearch', 'productMostView', 'productMostBuy', 'productLatest']),
		// ...mapState('store', ['detailStore']),

		window() {
			return window
		},

		networkID() {
			let dataUser = {
				user_network_id: 0
			}
			if (this.userData) {
				dataUser = this.userData
			}
			return dataUser.user_network_id
		}
	},
	methods: {
		// ...mapActions('product', ['getProductAll', 'getProductMostSearch', 'getProductMostView', 'getProductMostBuy',	'getProductLatest', 'getProductSearch', 'getProductDetail']),
		// ...mapActions('store', ['getStoreDetail']),

		async loadLatestProduct() {
			let params = {
				limit: 10,
				page: 1,
				sort: 'product_input_datetime',
				dir: 'DESC'
			}
			this.getDisplayLatest(params)
		},
		
		async getAllBanner() {
			await this.$http
				.get(`/banner/get-banner?limit=0`)
				.then((res) => {
					const data = res.data.data.results
					if (data) {
						this.banner.slide = data.filter(item => item.banner_position == 'header_left')
						this.banner.rightBanner = data.filter(item => item.banner_position == 'header_right')
						this.banner.content = data.filter(item => item.banner_position == 'content')
					}
				})
				.catch((error) => {
					// err = error
					console.log(error)
				})
		},
		
		async getAllProduct() {
			await this.$http
				.get(`/store-product/get-store-product/${this.store_slug}`, {
					// ...this.apiHeaders
				})
				.then((res) => {
					const data = res.data.data
					this.allProduct.lists = data.results
					this.allProduct.pagination = data.pagination
				})
				.catch((error) => {
					// err = error
					console.log(error)
				})
		},

		async getMostBuyProduct() {
			await this.$http
				.get(`/store-product/get-store-product/${this.store_slug}/buy`, {
					// ...this.apiHeaders
				})
				.then((res) => {
					const data = res.data.data
					this.mostBuyProduct.lists = data.results
					this.mostBuyProduct.pagination = data.pagination
				})
				.catch((error) => {
					// err = error
					console.log(error)
				})
		},
		
		async getLatestProduct() {
			await this.$http
				.get(`/store-product/get-store-product/${this.store_slug}?limit=10&page=1&sort=product_input_datetime&dir=DESC`, {
					// ...this.apiHeaders
				})
				.then((res) => {
					const data = res.data.data
					this.latestProduct.lists = data.results
					this.latestProduct.pagination = data.pagination
				})
				.catch((error) => {
					// err = error
					console.log(error)
				})
		},

		async getStoreDetail() {
			await this.$http
				.get(`/store/detail-store/${this.store_slug}`, {
					// ...this.apiHeaders
				})
				.then((res) => {
					const data = res.data.data
					this.detailStore = data
					if (Object.keys(data).length > 0) localStorage.setItem('HwiEcomStore', this.store_slug)
				})
				.catch((error) => {
					// err = error
					console.log(error.response.data.message)
					
					// let l = this.$router.resolve({name: this.$route.name});
					// if( l.resolved.matched.length > 0){
					// 	console.log('path exist')
					// }else{
					// 	console.log('path NOT exist')
					// }
					this.store_slug = ''
					localStorage.removeItem('HwiEcomStore')
					let allowedPath = ['transaction', 'checkout', 'profile', 'product', 'seller', 'login-seller', 'reset-password-seller']
					if (!allowedPath.includes(this.$route.params.slug)) {
						this.$router.push("/").catch(() => {});
					}
				})
		},

		onResize() {
			if (window.innerWidth < 481) {
				this.isMobile = true
			} else if (window.innerWidth > 480 && window.innerWidth < 769) {
				this.isMobile = true
			} else {
				this.isMobile = false
			}
		},

		genSamples(data, loop) {
			let newdata = []
			for (let i = 0; i < loop; i++) {
				data.map((item) => {
					let prd = item
					newdata.push(prd)
				})
			}
			
			return newdata
		}
	},
	async created() {
		this.$store.dispatch('setPageTitle', `Beranda Store`);
		this.store_slug = await this.$route.params.slug
		this.loadingProduct = await true
		await this.getAllBanner()
		await this.getStoreDetail()
		this.getAllProduct()
		this.getLatestProduct()
		this.getMostBuyProduct()

		setTimeout(() => {
			this.loadingProduct = false
		}, 1200);
	},
};
</script>

<style lang="scss">
.box-product-img {
	display: flex;
	align-items: center;
	height: 155px;
}
</style>
